import React from "react";

import { ResourceTypeShape } from "../../policies/proptypes";

const ScopeTypeDescription = ({ resourceType }) => (
  <div className="l-scopes__column" style={{ gridArea: "scope-description" }}>
    <div className="l-scopes__column-header">
      <span className="p-muted-heading u-no-margin--bottom">Description</span>
    </div>
    <div className="l-scopes__column-panel" style={{ margin: "0 .5rem" }}>
      <p>{resourceType && resourceType.description}</p>
    </div>
  </div>
);

ScopeTypeDescription.propTypes = {
  resourceType: ResourceTypeShape
};

ScopeTypeDescription.defaultProps = {
  resourceType: undefined
};

export default ScopeTypeDescription;
